<tt-page *ngIf="!!get">
    <tt-card>
        <tt-select
            ttRememberId="w_accountingprocessing.businessco_no"
            ttLabel="businessco"
            [(ttModel)]="get.businessco_no"
            (ttModelChange)="readGrid()"
            [ttData]="companies"
            ttDataId="businessco_no"
            ttDataName="company_name"
        ></tt-select>
        <tt-date-range
            ttRememberId="w_acledgerview"
            ttLabel="date_fom_tom"
            [(ttStartDate)]="get.date_fom"
            [(ttEndDate)]="get.date_tom"
            [(ttInterval)]="get.dateselector_index"
            (ttModelChange)="readGrid()"
        ></tt-date-range>
        <tt-search-multi-select
            ttModelSetting="object"
            ttLabel="account_nos"
            [ttData]="searchAccounts"
            [(ttModel)]="get.account_nos!"
            (ttModelChange)="onAccountsChanged($event)"
            ttDataName="item_name"
            ttDataId="item_id"
            ttShowClearButton
        >
            <tt-form-field-button buttons ttId="search" ttIcon="fas fa-search" (ttClick)="readGrid()"></tt-form-field-button>
        </tt-search-multi-select>
        <tt-checkbox ttRememberId="w_acledgerview.show_account_saldo" ttLabel="show_account_saldo" [(ttModel)]="get.show_account_saldo" (ttModelChange)="readGrid()"></tt-checkbox>
        <tt-button ttText="acledgerview_retrieve" ttIcon="fas fa-sync-alt" [ttLoading]="loading" (ttClick)="readGrid()"></tt-button>
    </tt-card>
    <tt-grid *ngIf="grid" class="flex-1" [(ttOptions)]="grid" (ttOnRead)="loading = false"></tt-grid>
</tt-page>
